module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "padding": ".2rem 0 1rem 0"
    }
  }, [_c('van-pull-refresh', {
    on: {
      "refresh": _vm.onRefresh
    },
    model: {
      value: (_vm.isLoading),
      callback: function($$v) {
        _vm.isLoading = $$v
      },
      expression: "isLoading"
    }
  }, [_c('van-form', {
    staticStyle: {
      "min-height": "90vh"
    },
    on: {
      "submit": _vm.onSubmit,
      "failed": _vm.onFailed
    }
  }, [_vm._l((_vm.row.member_list), function(member, index) {
    return _c('div', {
      key: index
    }, [_c('van-divider', [_vm._v("人员信息" + _vm._s(index + 1) + "\n        ")]), _vm._v(" "), _c('van-cell-group', [_c('van-cell', {
      attrs: {
        "readonly": "",
        "input-align": "right",
        "title": '人员' + (index + 1),
        "label": member.num,
        "value": member.name
      },
      scopedSlots: _vm._u([{
        key: "right-icon",
        fn: function() {
          return undefined
        },
        proxy: true
      }], null, true)
    }), _vm._v(" "), _c('van-field', {
      attrs: {
        "name": "radio",
        "label": "性别",
        "input-align": "right"
      },
      scopedSlots: _vm._u([{
        key: "input",
        fn: function() {
          return [_c('van-radio-group', {
            attrs: {
              "direction": "horizontal"
            },
            model: {
              value: (member.sex),
              callback: function($$v) {
                _vm.$set(member, "sex", $$v)
              },
              expression: "member.sex"
            }
          }, [_c('van-radio', {
            attrs: {
              "checked-color": "#ffb01b",
              "name": "男"
            }
          }, [_vm._v("男")]), _vm._v(" "), _c('van-radio', {
            attrs: {
              "checked-color": "#ffb01b",
              "name": "女"
            }
          }, [_vm._v("女")])], 1)]
        },
        proxy: true
      }], null, true)
    }), _vm._v(" "), _c('van-field', {
      attrs: {
        "rules": [],
        "error-message-align": "right",
        "label": "微信号",
        "input-align": "right",
        "clearable": "",
        "placeholder": "请输入微信号"
      },
      model: {
        value: (member.weixin),
        callback: function($$v) {
          _vm.$set(member, "weixin", $$v)
        },
        expression: "member.weixin"
      }
    }), _vm._v(" "), _c('van-field', {
      attrs: {
        "rules": [{
          required: true,
          message: '请输入正确的手机号'
        }],
        "error-message-align": "right",
        "label": "手机",
        "input-align": "right",
        "clearable": "",
        "placeholder": "请输入手机"
      },
      model: {
        value: (member.phone),
        callback: function($$v) {
          _vm.$set(member, "phone", $$v)
        },
        expression: "member.phone"
      }
    }), _vm._v(" "), _c('van-cell', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.row.gametype == 3),
        expression: "row.gametype == 3"
      }],
      attrs: {
        "center": "",
        "title": "是否参加能力测试"
      },
      scopedSlots: _vm._u([{
        key: "right-icon",
        fn: function() {
          return [_c('van-switch', {
            attrs: {
              "active-color": "#ffad19",
              "active-value": 1,
              "inactive-value": 2,
              "size": "24"
            },
            model: {
              value: (member.is_join_exame),
              callback: function($$v) {
                _vm.$set(member, "is_join_exame", $$v)
              },
              expression: "member.is_join_exame"
            }
          })]
        },
        proxy: true
      }], null, true)
    }), _vm._v(" "), _c('van-field', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.row.gametype == 3),
        expression: "row.gametype == 3"
      }],
      attrs: {
        "error-message-align": "right",
        "label": "技术等级测试项目",
        "input-align": "right",
        "clearable": "",
        "placeholder": "请输入技术等级测试项目"
      },
      model: {
        value: (member.join_exame_name),
        callback: function($$v) {
          _vm.$set(member, "join_exame_name", $$v)
        },
        expression: "member.join_exame_name"
      }
    }), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.row.gametype == 3),
        expression: "row.gametype == 3"
      }],
      staticClass: "operate-desc-left"
    }, [_vm._v("技巧/花球/街舞/爵士")]), _vm._v(" "), _c('van-field', {
      attrs: {
        "readonly": "",
        "clickable": "",
        "input-align": "right",
        "error-message-align": "right",
        "label": "服务套餐",
        "rules": [{
          required: true,
          message: '请选择服务套餐'
        }]
      },
      model: {
        value: (member.serviceName),
        callback: function($$v) {
          _vm.$set(member, "serviceName", $$v)
        },
        expression: "member.serviceName"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "operate-desc-left"
    }, [_vm._v(_vm._s(member.serviceDesc))]), _vm._v(" "), _vm._l((_vm.row.extra_field), function(field, fileindex) {
      return _c('div', {
        key: fileindex
      }, [(field.type == 'text') ? _c('div', [_c('van-field', {
        attrs: {
          "rules": [{
            required: field.required,
            message: '请输入' + field.label
          }],
          "error-message-align": "right",
          "label": field.label,
          "input-align": "right",
          "clearable": "",
          "placeholder": '请输入' + field.label
        },
        model: {
          value: (member.jsondata[field.label]),
          callback: function($$v) {
            _vm.$set(member.jsondata, field.label, $$v)
          },
          expression: "member.jsondata[field.label]"
        }
      })], 1) : _vm._e(), _vm._v(" "), (field.type == 'select') ? _c('div', [_c('van-field', {
        attrs: {
          "name": "radio",
          "label": field.label,
          "rules": [{
            required: field.required,
            message: '请选择' + field.label
          }],
          "input-align": "right"
        },
        scopedSlots: _vm._u([{
          key: "input",
          fn: function() {
            return [_c('van-radio-group', {
              attrs: {
                "direction": "horizontal"
              },
              model: {
                value: (member.jsondata[field.label]),
                callback: function($$v) {
                  _vm.$set(member.jsondata, field.label, $$v)
                },
                expression: "member.jsondata[field.label]"
              }
            }, _vm._l((field.rules), function(frv, fri) {
              return _c('van-radio', {
                key: fri,
                attrs: {
                  "checked-color": "#ffb01b",
                  "name": frv
                }
              }, [_vm._v(_vm._s(frv))])
            }), 1)]
          },
          proxy: true
        }], null, true)
      })], 1) : _vm._e(), _vm._v(" "), (field.type == 'checkbox') ? _c('div', [_c('van-field', {
        attrs: {
          "name": "radio",
          "label": field.label,
          "input-align": "right",
          "rules": [{
            validator: _vm.validator.arrayMin,
            trigger: 'change',
            min: field.required ? 1 : 0,
            message: '请至少选择一项',
          }]
        },
        scopedSlots: _vm._u([{
          key: "input",
          fn: function() {
            return [_c('van-checkbox-group', {
              attrs: {
                "direction": "horizontal"
              },
              model: {
                value: (member.jsondata[field.label]),
                callback: function($$v) {
                  _vm.$set(member.jsondata, field.label, $$v)
                },
                expression: "member.jsondata[field.label]"
              }
            }, _vm._l((field.rules), function(frv, fri) {
              return _c('van-checkbox', {
                key: fri,
                attrs: {
                  "checked-color": "#ffb01b",
                  "name": frv
                }
              }, [_vm._v(_vm._s(frv))])
            }), 1)]
          },
          proxy: true
        }], null, true)
      })], 1) : _vm._e(), _vm._v(" "), (field.type == 'pic') ? _c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (!((_vm.row.cplimits.length > 0 || _vm.row.jllimits.length > 0) && field.label == '资质证明' && member.levelPass)),
          expression: "!((row.cplimits.length>0||row.jllimits.length>0) &&field.label=='资质证明'  && member.levelPass)"
        }]
      }, [_c('van-field', {
        attrs: {
          "formatter": function () {
            return ''
          },
          "name": "radio",
          "label": field.label,
          "rules": [{
            validator: _vm.validator.arrayMin,
            trigger: 'change',
            min: field.required ? 1 : 0,
            message: '请上传/选择图片',
          }],
          "input-align": "right"
        },
        model: {
          value: (member.jsondata[field.label]),
          callback: function($$v) {
            _vm.$set(member.jsondata, field.label, $$v)
          },
          expression: "member.jsondata[field.label]"
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "row"
      }, [_c('PicUploader', {
        attrs: {
          "fileList": member.jsondata[field.label],
          "limit": 1,
          "name": 'heying'
        }
      })], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (field.desc && !((_vm.row.cplimits.length > 0 || _vm.row.jllimits.length > 0) && field.label == '资质证明' && member.levelPass)),
          expression: "field.desc && !((row.cplimits.length>0||row.jllimits.length>0) &&field.label=='资质证明'  && member.levelPass)"
        }],
        staticClass: "operate-desc-left",
        on: {
          "click": function($event) {
            return _vm.fieldclick(field)
          }
        }
      }, [_vm._v(_vm._s(field.desc))])])
    })], 2)], 1)
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "100px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "savebtn"
  }, [_c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": "",
      "disabled": _vm.saveLoading,
      "loading": _vm.saveLoading,
      "loading-text": "提交中..."
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("\n          保存\n        ")])], 1)], 2)], 1), _vm._v(" "), (_vm.row.gametype == 3) ? _c('van-button', {
    staticStyle: {
      "bottom": "80px",
      "right": "10px",
      "z-index": "10",
      "position": "fixed"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": "",
      "round": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.showTemplate = true
      }
    }
  }, [_vm._v("导入模板\n  ")]) : _vm._e(), _vm._v(" "), (_vm.row.member_list.length > 0) ? _c('van-popup', {
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.showServiceTypePicker),
      callback: function($$v) {
        _vm.showServiceTypePicker = $$v
      },
      expression: "showServiceTypePicker"
    }
  }, [_c('van-picker', {
    attrs: {
      "columns": _vm.serviceTypeColumns,
      "show-toolbar": "",
      "default-index": _vm.row.member_list[_vm.thisMemberIndex].serviceType - 1
    },
    on: {
      "cancel": function($event) {
        _vm.showServiceTypePicker = false
      },
      "confirm": _vm.onServiceConfirm
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('van-popup', {
    style: ({
      height: '50%'
    }),
    attrs: {
      "position": "bottom"
    },
    on: {
      "click-overlay": function($event) {
        _vm.addShow = false
      }
    },
    model: {
      value: (_vm.addShow),
      callback: function($$v) {
        _vm.addShow = $$v
      },
      expression: "addShow"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "0.2rem",
      "margin-bottom": "1.5rem"
    }
  }, [_c('van-form', {
    on: {
      "submit": _vm.onMemberSubmit,
      "failed": _vm.onFailed
    }
  }, [_c('van-divider', [_vm._v("新增人员")]), _vm._v(" "), _c('van-cell-group', [_c('van-field', {
    attrs: {
      "label": "姓名",
      "rules": [{
        required: true,
        message: '姓名不能为空'
      }],
      "error-message-align": "right",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入姓名"
    },
    model: {
      value: (_vm.formData.name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "name", $$v)
      },
      expression: "formData.name"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "readonly": "",
      "clickable": "",
      "right-icon": "arrow",
      "input-align": "right",
      "label": "证件类型"
    },
    on: {
      "click": function($event) {
        _vm.showNumTypePicker = true
      }
    },
    model: {
      value: (_vm.formData.numTypeName),
      callback: function($$v) {
        _vm.$set(_vm.formData, "numTypeName", $$v)
      },
      expression: "formData.numTypeName"
    }
  }), _vm._v(" "), _c('van-popup', {
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.showNumTypePicker),
      callback: function($$v) {
        _vm.showNumTypePicker = $$v
      },
      expression: "showNumTypePicker"
    }
  }, [_c('van-picker', {
    attrs: {
      "columns": _vm.numTypeColumns,
      "show-toolbar": "",
      "default-index": _vm.formData.cardtype - 1
    },
    on: {
      "cancel": function($event) {
        _vm.showNumTypePicker = false
      },
      "confirm": _vm.onNumTypeConfirm
    }
  })], 1), _vm._v(" "), (_vm.formData.cardtype == 1) ? _c('van-field', {
    attrs: {
      "rules": [{
        validator: _vm.validator.idCard,
        message: '请输入正确的身份证号'
      }],
      "error-message-align": "right",
      "label": "身份证号",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入身份证号"
    },
    model: {
      value: (_vm.formData.num),
      callback: function($$v) {
        _vm.$set(_vm.formData, "num", $$v)
      },
      expression: "formData.num"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.formData.cardtype != 1) ? _c('van-field', {
    attrs: {
      "label": "证件号码",
      "rules": [{
        required: true,
        message: '证件号码不能为空'
      }],
      "error-message-align": "right",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入证件号码"
    },
    model: {
      value: (_vm.formData.huzhao),
      callback: function($$v) {
        _vm.$set(_vm.formData, "huzhao", $$v)
      },
      expression: "formData.huzhao"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "savebtn"
  }, [_c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": "",
      "disabled": _vm.saveLoading,
      "loading": _vm.saveLoading,
      "loading-text": "提交中...",
      "native-type": "submit"
    }
  }, [_vm._v("确定\n          ")])], 1)], 1)], 1)]), _vm._v(" "), _c('van-dialog', {
    attrs: {
      "title": "衣服尺码表"
    },
    model: {
      value: (_vm.cSizeShow),
      callback: function($$v) {
        _vm.cSizeShow = $$v
      },
      expression: "cSizeShow"
    }
  }, _vm._l((_vm.cSizePicList), function(pic, key) {
    return _c('img', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "src": pic
      },
      on: {
        "click": function($event) {
          return _vm.picShow(key, _vm.cSizePicList)
        }
      }
    })
  }), 0), _vm._v(" "), _c('van-dialog', {
    attrs: {
      "title": "鞋码表"
    },
    model: {
      value: (_vm.fSizeShow),
      callback: function($$v) {
        _vm.fSizeShow = $$v
      },
      expression: "fSizeShow"
    }
  }, [_c('p', {
    staticStyle: {
      "padding": "10px",
      "text-align": "center"
    }
  }, [_vm._v("此鞋型偏小，建议选大一码")]), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": _vm.fSizePicList[0]
    },
    on: {
      "click": function($event) {
        return _vm.picShow(0, _vm.fSizePicList)
      }
    }
  })]), _vm._v(" "), _c('van-dialog', {
    attrs: {
      "title": "导入模板信息"
    },
    model: {
      value: (_vm.showTemplate),
      callback: function($$v) {
        _vm.showTemplate = $$v
      },
      expression: "showTemplate"
    }
  }, [_c('div', {
    staticClass: "operate-desc-left"
  }, [_vm._v("复制下面的链接，用电脑端打开，进行批量导入操作")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.row.share),
      expression: "row.share",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.onCopy),
      expression: "onCopy",
      arg: "success"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:error",
      value: (_vm.onError),
      expression: "onError",
      arg: "error"
    }],
    staticClass: "operate-desc-left",
    staticStyle: {
      "color": "#666"
    }
  }, [_vm._v("导入模板链接地址：" + _vm._s(_vm.row.share) + "\n      "), _c('div', {
    staticClass: "small-button"
  }, [_vm._v("复制")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-17558978","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/huiyi/HuiyiApplyFormStepC2.vue
// module id = 2232
// module chunks = 0